//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";

import {
  Col,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Row,
  Table,
  Tooltip,
  Typography,
  message,
} from "antd";
import { ColumnGroupType, TableProps } from "antd/es/table";
import { Button, Dropdown, Flex, Layout, Menu, Tabs } from "antd";
import { Header } from "antd/es/layout/layout";
import Title from "antd/es/typography/Title";
import { BsThreeDotsVertical } from "react-icons/bs";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import { EditOutlined } from "@ant-design/icons";
import * as AntIcons from "@ant-design/icons";
import FormTable from "../DynamicTable/FormTable";
import { stat } from "fs";
import { APICall } from "../../Helpers/APICalls/APICalls";
import MyTableConfig from "../../Home/DynamicTableExampleConfig.json";
import {
  generateReport,
  fetchReportData,
  fetchReportExcelData,
  executeLockUnlock,
  executeReportAction,
} from "../../Helpers/APIEndpoints/Endpoints";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "../../Axios/Axios";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { LoaderContext } from "../../Helpers/Context/Context";
import { useActionHandler } from "../ActionHandlerContext";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: Item;
  index: number;
  children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType ? (
    inputType === "number" ? (
      <InputNumber />
    ) : (
      <Input />
    )
  ) : (
    <Input />
  );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

interface DynamicDashboardProps {
  // id: number;
  // dashboardId: number;
  props: any;
}

// Apply Loaders and Other things // Convert it into Component
//Comments also check validations on filter  on change
const DynamicReport: React.FC<DynamicDashboardProps> = ({
  // id,
  // dashboardId,
  ...props
}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [dataConfig, setDataConfig] = useState(null);
  const [editingKey, setEditingKey] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState("Actions");
  const [columns, setColumns] = useState([]);
  const [filters, setFilters] = useState([]);
  const [filtersvalue, setFiltersValue] = useState("");
  const [isTableLoading, setTableLoading] = useState<boolean>(false);
  const [isReset, setIsReset] = useState(false);
  const [selectRecordIds, setSelectRecordIds] = useState([]);
  const location = useLocation();
  const { state } = location || {};
  const navigate = useNavigate(); // Ho
  const [interfaceId, setInterfaceId] = useState<Number>(
    state?.id || props?.id
  );
  const [stateDashboardId, setStateDashboardId] = useState<Number>(
    state?.dashboardId || props?.dashboardId || 0
  );
  // console.log('interface id ', interfaceId)
  // console.log('dashboardId', dashboardId)
  // console.log('location pathname', location.pathname)
  const [totalcount, setTotlaCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [actionButtons, setActionButtons] = useState([]);
  const [pageButtons, setPageButtons] = useState([]);
  const [enableSearch, setenableSearch] = useState<Boolean>();
  const [checkBoxFlag, setcheckBoxFlag] = useState<Boolean>();
  const { rowActionHandler, reportActionHandler } = useActionHandler();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { userId, currentRoleId, permissionRecord, currentFinancialYearId, currentuserroleList } =
    useAuthStore();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // let TotalCount = 0;

  // Function to navigate with ID
  const handleNavigation = (id: Number, actionType: String, RId: Number) => {
    if (props?.handleCreate) {
      props?.handleCreate(actionType, RId);
    } else {
      navigate("/InterfaceComponent", {
        state: { id, actionType, RId },
      });
    }
  };

  // const getIcon = (iconName) => {
  //   const Icon = AntIcons[iconName];
  //   if (Icon) {
  //     return <Icon />;
  //   }
  //   // If icon name is not found, return null or a default icon (optional)
  //   return null;
  // };

  const getIcon = (iconName) => {
    const Icon = AntIcons[iconName];
    if (Icon) {
      return <Icon />;
    }
    // If icon name is not found, return null or a default icon (optional)
    return null;
  };

  const downloadExcel = async (formValue = null, Querry = "") => {
    try {
      showLoader();
      let formValueWithFilters = { ...formValue, ...filtersvalue, searchText };

      let response = await API.post(fetchReportExcelData, {
        // currently Hardcoaded
        UserId: userId,
        RoleId: currentRoleId,
        // PageNumber: PageNumber,
        // PageSize: PageSize,
        // sortBy: "Title",
        // desc: true,
        FormData:
          formValue != null ? JSON.stringify(formValueWithFilters) : null,
        ReportName: dataConfig?.name || "Report",
        //ReportQuery: Querry != "" ? Querry : dataConfig?.reportQuery,
        ActionType: "DynamicReportActionExportToExcel",
        ReportId: stateDashboardId,        
      });

      if (response.data.message != "OK") throw new Error("Download failed");

      downloadFile(
        response.data.data.fileContents,
        response.data.data.fileDownloadName,
        response.data.data.contentType
      );
      hideLoader();
    } catch (error) {
      console.error("Error downloading file:", error);
      hideLoader();
    }
  };

  function downloadFile(base64String, fileName, contentType) {
    // Convert Base64 to a binary buffer
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (!state?.id && !props?.id) {
      return;
    }
    setInterfaceId(state?.id || props?.id || 0);
    setStateDashboardId(state?.dashboardId || stateDashboardId);
  }, [state]);

  useEffect(() => {
    if (!stateDashboardId) {
      return;
    }
    console.log('filter values is', filtersvalue)
    getReportConfig();
  }, [stateDashboardId,filtersvalue]);

  const getReportConfig = async () => {
    try {
      showLoader();
      let reportConfigResponse = await API.post(generateReport, {
        ReportId: stateDashboardId,
        InterfaceId: interfaceId,
        formData: JSON.stringify({ CurrentFyId: currentFinancialYearId }),
      });
      if (reportConfigResponse?.data != null) {
        getReportData(
          filtersvalue
          //null,
          //reportConfigResponse?.data?.data?.config?.reportQuery
        );
        // console.log(
        //   "reportConfigResponse?.data:::::",
        //   reportConfigResponse?.data?.data
        // );
        setDataConfig(reportConfigResponse?.data?.data?.config);
        // const newColumns = reportConfigResponse?.data?.data?.columns.map((item) => (console.log('current column is ',item)));
        const checkedList = ["Verifier Name","Total Doc","Verifier Last Modified On"]
        const newColumns = reportConfigResponse?.data?.data?.columns.map((item) => ({
            ...item,
            hidden: (stateDashboardId == 10 && (filtersvalue?.CategoryType == 2 || filtersvalue?.CategoryType == "Declaration" || filtersvalue?.CategoryType == undefined) ) && checkedList.includes(item.key as string),
          }));
        setColumns(newColumns || reportConfigResponse?.data?.data?.columns);
        setenableSearch(
          reportConfigResponse?.data?.data?.config?.enableContentSearch
        );
        // console.log(
        //   "reportConfigResponse?.data?.columns:::::::",
        //   reportConfigResponse?.data?.data?.columns
        // );
        setFilters(reportConfigResponse?.data?.data?.filters);
        // console.log(
        //   "reportConfigResponse?.data?.filters:::::::",
        //   reportConfigResponse?.data?.data?.filters
        // );

        // setenableSearch(false);

        const reportSetting = JSON.parse(
          reportConfigResponse?.data?.data?.config?.reportSetting
        );
        setcheckBoxFlag(reportSetting?.RowSelector);

        setActionButtons(
          JSON.parse(reportConfigResponse?.data?.data?.config?.rowActionConfig)
        );
        console.log(JSON.parse(reportConfigResponse?.data?.data?.config?.rowActionConfig))
        setPageButtons(
          JSON.parse(
            reportConfigResponse?.data?.data?.config?.reportActionConfig
          )
        );
        //console.log(JSON.parse(reportConfigResponse?.data?.data?.config?.reportActionConfig));
      }
      hideLoader();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  useEffect(() => {
    getReportData(filtersvalue);
  }, [searchText]);

  const getReportData = async (
    formValue = null,
    //Querry = "",
    PageSize = 10,
    PageNumber = 1
  ) => {
    try {
      showLoader();
      let fetchResponse = await API.post(fetchReportData, {
        // currently Hardcoaded
        UserId: userId,
        RoleId: currentRoleId,
        PageNumber: PageNumber,
        PageSize: PageSize,
        sortBy: "ModifiedDateUtc",
        desc: true,
        FormData: formValue != null ? JSON.stringify(formValue) : null,
        //ReportQuery: Querry != "" ? Querry : dataConfig?.reportQuery,
        ReportId: stateDashboardId,
        SearchText: searchText,
        FinancialYearId : stateDashboardId == 10 ? currentFinancialYearId : 0,
      });

      if (fetchResponse?.data?.data?.length > 0) {
        //console.log("fetchResponse::::::::::", fetchResponse);

        // Add a new key-value pair to each object inside fetchResponse.data
        const updatedData = fetchResponse.data.data.map((item) => ({
          ...item, // Spread existing object properties
          key: item?.key,
          interfaceId: state?.id || props?.id || 0, // Add your new key-value pair
        }));
        //console.log("updatedData Count::::::::::", updatedData[0].TotalCount);
        setTotlaCount(updatedData[0].TotalCount);

        setData(updatedData);
        setPage(PageNumber);
      } else {
        console.log("fetchResponse is empty or undefined");

        // Handle empty response scenario
        setTotlaCount(0); // Reset total count
        setData([]); // Ensure data is cleared or set to an empty array
        setPage(0);
      }
      hideLoader();
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const isEditing = (record: Item) => record.key === editingKey;

  const edit = (record: any & { key: React.Key }) => {
    const finobj = columns?.reduce((acc, curr) => {
      acc[curr.key] = "";
      return acc;
    }, {});

    //console.log("finobj:::::::", finobj);
    form.setFieldsValue(finobj);
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newKeys) => setSelectedRowKeys(newKeys),
  };

  // const rowSelection: TableProps<unknown>["rowSelection"] = {
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: unknown[]) => {
  //     console.log(
  //       `selectedRowKeys: ${selectedRowKeys}`,
  //       "selectedRows: ",
  //       selectedRows
  //     );
  //     setSelectRecordIds(selectedRowKeys)
  //   },
  //   getCheckboxProps: (record: unknown) => ({
  //     disabled: record?.["name"] === "Disabled User", // Column configuration not to be checked
  //     name: record?.["name"],
  //   }),
  // };

  const [loadingState, setLoadingState] = useState({});

  // const reportActionHandlerNew = {
  //   ...reportActionHandler,
  //   Create: async (actionType: string, ...params: any[]) => {
  //     console.log(`${params[1]} 333 action with parameters:`, params);
  //     await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulate 1-second delay
  //     return true;
  //   },
  // };

  const handleActionButtonClick = async (
    button: any,
    recordId: any,
    record: any
  ) => {
    const { type, ...params } = button;

    // console.log("record===>", record);
    // console.log('recordId ===>',recordId)
    // console.log("buttons===>", button);
    // console.log('loading stateis ',loadingState)
    setLoadingState((prevState) => ({
      ...prevState,
      [recordId]: { ...prevState[recordId], [type]: true },
    }));

    try {
     // if (true) {
      if (rowActionHandler[type]) {
        // Call the appropriate handler and wait for the result (if it's async)
        const result = await rowActionHandler[type](type, record);
        // Handle success
        if (type === "DynamicMasterRowDelete") {
          getReportData(filtersvalue);
        }
        if (result) {
          // message.success(
          //   `Handler for ${type} executed successfully: ${result}`
          // );
          console.error(
            `Handler for "${type}" executed successfully: ${result}`
          );
          if (
            type === "DynamicMasterRowDelete" ||
            type === "DynamicMasterRowReset" 
          ) {
            await getReportData(filtersvalue);
          }
          if (
            type == "DynamicMasterBulkDownload"
          ) {
           await getReportData(filtersvalue);
          }
          if (
            type == "DynamicMasterViewDeclaration"
          ) {
            return;
          // await getReportData(filtersvalue);
          }
        }
      } else {
        message.error(`No handler found for ${type}`);
      }
    } catch (error) {
      // Handle error
      message.error(`Error executing handler for ${type}: ${error.message}`);
    } finally {
      // Set the loading state for the specific record and button to false
      setLoadingState((prevState) => ({
        ...prevState,
        [recordId]: { ...prevState[recordId], [type]: false },
      }));
    }
  };

  const clearSelection = async () => {
    //setSelectRecordIds([]); // Reset selected checkboxes
    setTimeout(() => {
      setSelectedRowKeys([]);
      hideLoader();
    }, 1000);
    getReportData();

    // navigate(0)
  };

  const handleLockUnlockClick = async (currentType: string) => {
    showLoader();
    console.log("rowsSelection is ---->", selectedRowKeys);
    console.log("currentType", currentType);
    if (selectedRowKeys.length <= 0) {
      message.error("No record selected");
      hideLoader();
      return;
    }
    const requestParam = {
      RecordIds: selectedRowKeys.join(","),
      ActionType: currentType,
      ModifiedBy:Number(userId),
      ExecutionMessage: "",
    };
    let lockunlockRes = await API.post(executeLockUnlock, requestParam);
    console.log("lockunlock res", lockunlockRes);
    if (
      lockunlockRes?.status === 200 &&
      lockunlockRes?.data?.data?.executionMessage
    ) {
      const ExecutionMessage = lockunlockRes?.data?.data?.executionMessage;
      if (lockunlockRes?.data?.data?.Id) {
        clearSelection().then(() => {
          message.success(ExecutionMessage);
        });
        getReportData();
      } else if (!lockunlockRes?.data?.data?.Id) {
        hideLoader();
        message.error(ExecutionMessage);
      }
    } else {
      message.error("Failed to lock/unlock.");
      hideLoader();
    }
  };

  const handlePageActionClick = async (button: any) => {
    setLoadingState((prev) => ({ ...prev, [button.label]: true }));
    try {
      // if action object is empty for buttons
      if (!button?.actions || button?.actions?.length === 0) {
        console.error(`No action found for this ${button.label} button`);
        return;
      }
      let formValue = { ...form.getFieldsValue() };

      //for export to excel call downloadExcel only
      if (button?.actionType === "DynamicReportActionExportToExcel") {
        downloadExcel(formValue, stateDashboardId);
      } else {
        // for all other buttons
        for (const action of button.actions) {
          const { execType, execData } = action;
          let result;
          if (execType === "Function") {
            if (!reportActionHandler[execData]) {
              console.error(`No handler found for function: ${button.label}`);
              return;
            }
            result = await reportActionHandler[execData](
              button.actionType,
              button
            );
          } else if (execType === "Query" || execType === "SP") {
            // if (!reportActionHandler[execType]) {
            //   console.error(`No handler found for Query/SP: ${button.label}`);
            //   return;
            // }
            // result = await reportActionHandler[execData](button);
            result = await API.post(executeReportAction, {
              ReportId: stateDashboardId,
              ActionType: button.actionType,
              ActionId: action.actionId,
              FormData: JSON.stringify(formValue),
            });
            if (result?.data?.status == 1) {
              message.error(`Failed.`);
              console.log(
                button.actionId + " failed : " + result?.data?.message
              );
            } else if (result?.data?.status > 0) {
              message.warning(result?.data?.message);
            }
          } else {
            console.error(`Unsupported execType: ${execData}`);
            return;
          }
          if (!result) {
            // message.error(
            //   `Handler for "${button.label}" executed but returned no result.`
            // );
            console.error(
              `Handler for "${button.label}" executed but returned no result.`
            );
            return;
          } else {
            // message.success(
            //   `Handler for "${button.label}" executed successfully: ${result}`
            // );
            console.error(
              `Handler for "${button.label}" executed successfully: ${result}`
            );
          }
        }
      }
    } catch (error) {
      console.error(`No action found for this ${button.label}:`, error);
      message.error(`No action found for this ${button.label}`);
    } finally {
      setLoadingState((prev) => ({ ...prev, [button.label]: false }));
    }
  };

  // const actionColumn = {
  //   title: "Actions",
  //   key: "actions",
  //   fixed: "right",
  //   width: 100,
  //   render: (_, record) => (
  //     <div style={{ display: "flex", gap: "8px" }}>
  //       {actionButtons?.map((button: any, index: number) => (
  //         <Tooltip title={button.label}>
  //           <Button
  //             key={index}
  //             icon={getIcon(button.icon)}
  //             onClick={() =>
  //               handleActionButtonClick(button, record.key, record)
  //             }
  //             type="link"
  //             title={button.type}
  //             loading={loadingState[record.key]?.[button.type]}
  //           ></Button>
  //         </Tooltip>
  //       ))}
  //     </div>
  //   ),
  // };
  console.log("stateDashboardId==>", stateDashboardId);

  const actionColumn = {
    title: "Actions",
    key: "actions",
    fixed: "right",
    width: 100,
    render: (_, record) => {
      if (stateDashboardId != 10) {
        return (
          <div style={{ display: "flex", gap: "8px" }}>
            {actionButtons?.map((button: any, index: number) => (
              <Tooltip title={button.label}>
                <Button
                  key={index}
                  icon={getIcon(button.icon)}
                  onClick={() =>
                    handleActionButtonClick(button, record.key, record)
                  }
                  type="link"
                  loading={loadingState[record.key]?.[button.type]}
                ></Button>
              </Tooltip>
            ))}
          </div>
        );
        // return <Tooltip title={button.label} key={index}>
        //         <Button
        //           icon={getIcon(button.icon)}
        //           onClick={() =>
        //             handleActionButtonClick(button, record.key, record)
        //           }
        //           type="link"
        //           title={button.type}
        //           loading={loadingState[record.key]?.[button.type]}
        //         />
        //       </Tooltip>;
      } else {
        const actionElements = [];
        console.log('record is -> ',record)
        actionButtons?.forEach((button: any, index: number) => {
          const isEdit = button.label === "Edit";
          const isReset = button.label === "Reset";
          const isDownload = button.label === "Download";

          const PendingUserIds = record?.PendingWithUserId?.toString()?.split(',')?.map(id => id?.trim());
          const IsPending = record?.Status.toLowerCase() === "pending";

          if (isDownload) return;

          if (isEdit && !IsPending && 
            
            ((currentuserroleList.some((currentrole) => currentrole.Id == 1 || currentrole.Id == 2)) ||
            (PendingUserIds?.includes(userId.toString())))
            && (filtersvalue?.CategoryType == 1 )
          ) {
              
            //(record.VerifierName && record.VerifierName != " ") )) {
            actionElements.push(
              <Tooltip title={button.label} key={`edit-${index}`}>
                <Button
                  icon={getIcon(button.icon)}
                  onClick={() =>
                    handleActionButtonClick(button, record.key, record)
                  }
                  type="link"
                  title={button.type}
                  loading={loadingState[record.key]?.[button.type]}
                />
              </Tooltip>
            );
          } else if (
              isReset &&
              (
                (
                  currentuserroleList.some((currentrole) => currentrole.Id == 1 || currentrole.Id == 2)
                ) ||
                (
                   PendingUserIds?.includes(userId.toString())
                )
              ) &&
              (
                record.Status == "Approved" ||
                record.Status == "Rejected" ||
                record.Status == "Partially Accepted"
              )
              && (filtersvalue?.CategoryType == 1 )
            )
          {
            actionElements.push(
              <Tooltip title={button.label} key={`reset-${index}`}>
                <Button
                  icon={getIcon(button.icon)}
                  onClick={() =>
                    handleActionButtonClick(button, record.Key, record)
                  }
                  type="link"
                  title={button.type}
                  loading={loadingState[record.Key]?.[button.type]}
                />
              </Tooltip>
            );
          }
        });

        const downloadButton = actionButtons?.find(
          (btn: any) => btn.label === "Download"
        );
        console.log('downladbuttons is ',downloadButton)
        if (downloadButton && (filtersvalue?.CategoryType == 1 )) {
          actionElements.push(
            <Tooltip title={downloadButton.label} key="download">
              <Button
                icon={getIcon(downloadButton.icon)}
                onClick={() =>
                  handleActionButtonClick(downloadButton, record.Key, record)
                }
                type="link"
                title={downloadButton.type}
                loading={loadingState[record.Key]?.[downloadButton.type]}
              />
            </Tooltip>
          );
        }
        // sangam - for bulk download documents in zip folder

        const BulkdownloadButton = actionButtons?.find(
          (btn: any) => btn.label === "Bulk Download"
        );
        console.log('record?',record)
        console.log('record?.TotalDoc',record?.TotalDoc)
        console.log('filtersvalue',filtersvalue)
        if (BulkdownloadButton && record?.TotalDoc > 0 && (filtersvalue?.CategoryType == 1 ) ) {
          actionElements.push(
            <Tooltip title={'Bulk download'} key={`bulkdownload-${record.Key}`}>
              {/* <AntIcons.FolderTwoTone
                onClick={() =>
                  handleActionButtonClick({label:"Bulk Download",type:"DynamicMasterBulkDownload"}, record.key, record)
                }
              /> */}
              <Button
                key={record.Key}
                icon={getIcon(BulkdownloadButton.icon)}
                onClick={() =>
                  handleActionButtonClick(BulkdownloadButton, record.Key, record)
                }
                type="link"
                title={BulkdownloadButton.type}
                loading={loadingState[record.Key]?.[BulkdownloadButton.type]}
              />
            </Tooltip>
          );
        }


         const ViewDeclarationButton = actionButtons?.find(
          (btn: any) => btn.label === "View Declaration"
        );
        console.log('record?',record)
        console.log('record?.TotalDoc',record?.TotalDoc)
        console.log('filtersvalue',filtersvalue)
        if (ViewDeclarationButton && (filtersvalue?.CategoryType == 2 || filtersvalue?.CategoryType == "Declaration" || filtersvalue?.CategoryType == undefined ) ) {
          actionElements.push(
            <Tooltip title={'View Declaration'} key={`viewdeclaration-${record.Key}`}>
              <Button
                key={record.Key}
                icon={getIcon(ViewDeclarationButton.icon)}
                onClick={() =>
                  handleActionButtonClick(ViewDeclarationButton, record.Key, record)
                }
                type="link"
                title={ViewDeclarationButton.type}
                loading={loadingState[record.Key]?.[ViewDeclarationButton.type]}
              />
            </Tooltip>
          );
        }


        
        return (
          <div style={{ display: "flex", gap: "8px" }}>{actionElements}</div>
        );
      }
    },
  };

  // const actionColumn = {
  //   title: "Actions",
  //   key: "actions",
  //   fixed: "right",
  //   width: 100,
  //   render: (_, record) => (
  //     <div style={{ display: "flex", gap: "8px" }}>
  //       {actionButtons?.map((button: any, index: number) => {
  //         if (stateDashboardId == 10) {
  //           if (record.VerifierName && button.label == "Edit") {
  //             return <>
  //               <Tooltip title={button.label} key={index}>
  //               <Button
  //                 icon={getIcon(button.icon)}
  //                 onClick={() =>
  //                   handleActionButtonClick(button, record.key, record)
  //                 }
  //                 type="link"
  //                 title={button.type}
  //                 loading={loadingState[record.key]?.[button.type]}
  //               />
  //             </Tooltip>
  //             </>;
  //           } else if (record.PendingWithUserId == userId && button.label == "Reset" && (record.StatusId == 5 || record.StatusId == 6)) {
  //             return <>
  //               <Tooltip title={button.label} key={index}>
  //               <Button
  //                 icon={getIcon(button.icon)}
  //                 onClick={() =>
  //                   handleActionButtonClick(button, record.key, record)
  //                 }
  //                 type="link"
  //                 title={button.type}
  //                 loading={loadingState[record.key]?.[button.type]}
  //               />
  //             </Tooltip>
  //             </>;
  //           }else{
  //           return <>
  //           <Tooltip title={button.label} key={index}>
  //               <Button
  //                 icon={getIcon(button.icon)}
  //                 onClick={() =>
  //                   handleActionButtonClick(button, record.key, record)
  //                 }
  //                 type="link"
  //                 title={button.type}
  //                 loading={loadingState[record.key]?.[button.type]}
  //               />
  //             </Tooltip>
  //           </>;
  //           }
  //         } else {
  //           return (
  //             <></>
  //             // <Tooltip title={button.label} key={index}>
  //             //   <Button
  //             //     icon={getIcon(button.icon)}
  //             //     onClick={() =>
  //             //       handleActionButtonClick(button, record.key, record)
  //             //     }
  //             //     type="link"
  //             //     title={button.type}
  //             //     loading={loadingState[record.key]?.[button.type]}
  //             //   />
  //             // </Tooltip>
  //           );
  //         }
  //       })}
  //     </div>
  //   ),
  // };

  const mergedColumns = [
    ...columns?.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record: Item) => ({
          record,
          inputType: col.dataIndex === "age" ? "number" : "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        }),
      };
    }),
    stateDashboardId == 6 ? [] : actionColumn, // action column hide for employee master screen only
  ];

  const handleButtonClick = async (form: any, buttonConfig: any) => {
    try {
      if (buttonConfig === "reset") {
        form.resetFields();
        setIsReset(!isReset);
       
        
        let formValue = { ...form.getFieldsValue() };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            }
          });

          if (formValue.CategoryType === "Declaration") {
            formValue.CategoryType = 2;
          }

        }
        setFiltersValue(formValue);

        //clearing rowForm Data:
        getReportData();
       // message.info("Form reset successfully.");
        //console.log("Form reset successfully.");

        return;
      }

      if (buttonConfig.actionKey.toLowerCase() === "apply") {
        //await form.validateFields();
        let formValue = { ...form.getFieldsValue() };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            }
          });

          if (formValue.CategoryType === "Declaration") {
            formValue.CategoryType = 2;
           }
        }
        setFiltersValue(formValue);
        getReportData(formValue);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  // const functionMapping = {
  //   Create: (actionType: string, RId: string) => {
  //     props?.handleCreate(actionType, RId);
  //   },
  //   ExportToExcel: () => {
  //     let formValue = { ...form.getFieldsValue() };
  //     downloadExcel(formValue, dataConfig?.reportQuery);
  //   },
  //   SQL: () => {
  //     message.success("Executing function ");
  //   },
  // };
  //console.log(`pageButtons`, pageButtons);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 ">
          <div className="pageName">
            <Title level={4}>
              {dataConfig?.name}
              {/* Dynamic Head */}
            </Title>
          </div>
        </div>
      </div>
      {/* <div className="row">

        </div> */}
      <Form form={form} component={false}>
        <div className="row">
          <div className="col-lg-12">
            <FormTable
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              loading={isTableLoading}
              filters={filters}
              rowClassName="editable-row"
              dataSource={data}
              isAddRowTable
              columns={mergedColumns}
              scroll={{ x: "max-content", y: "calc(100vh - 200px)" }}
              // condition for check box only visible to employee master screen
              // {...(stateDashboardId == 6 && {
              //     rowSelection : { type : "checkbox" , ...rowSelection}
              // })}
              //
              rowSelection={stateDashboardId === 6 ? rowSelection : undefined}
              tableCheckbox={checkBoxFlag}
              showSearchInput={enableSearch}
              handleSearch={handleSearch}
              dashboardId={stateDashboardId}
              pageButtons={pageButtons}
              handlePageActionClick={handlePageActionClick}
              loadingState={loadingState}
              setLoadingState={setLoadingState}
              handleButtonClick={handleButtonClick}
              pagination={{
                total: totalcount,
                current: page,
                position: ["bottomRight"],
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: [5, 10, 20, 50, 100],
                onShowSizeChange: (current, size) => {
                  // console.log(
                  //   "Current: ",
                  //   current,
                  //   "Size: ",
                  //   size,
                  //   "totalcount",
                  //   totalcount
                  // );
                  setPageSize(size);
                  //setpage(current);
                  //getReportData(null, dataConfig?.reportQuery, size, current);
                  getReportData(null, size, current);
                },
                onChange: (current, size) => {
                  setPageSize(size);
                  setPage(current);
                  getReportData(
                    filtersvalue,
                    //dataConfig?.reportQuery,
                    size,
                    current
                  );
                },
              }}
            />
            {/* <div className="col-lg-12 d-flex justify-content-end mt-3">
              <Button className="updateBtn" onClick={() => handleNavigation(state?.id, "Update", 1)}>Update</Button>
            </div> */}
          </div>

          {stateDashboardId == 6 && (
            <div className="col-lg-12 mt-3 w-100 d-flex justify-content-end">
              <div className="Lock&Unloack">
                <Button
                  className="lock me-3"
                  onClick={() => handleLockUnlockClick("lock")}
                >
                  Lock
                </Button>
                <Button
                  className="btn-viewsub"
                  type=""
                  onClick={() => handleLockUnlockClick("unlock")}
                >
                  Unlock
                </Button>
              </div>
            </div>
          )}
        </div>
      </Form>
    </div>
  );
};

export default DynamicReport;
